import {
  SUBJECT_ROUTING_REQUEST,
  SUBJECT_ROUTING_SUCCESS,
  SUBJECT_ROUTING_FAILURE,
} from "../types/subjectRouting.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const SubjectRoutingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBJECT_ROUTING_REQUEST:
      return {
        ...state,
        storeItemResponse: "",
        loading: true,
      };
    case SUBJECT_ROUTING_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case SUBJECT_ROUTING_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default SubjectRoutingReducer;
